module.exports = __webpack_public_path__ + "static/media/039.47a139c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/039.jpg
// module id = 335
// module chunks = 0